const PENCOM_LOGO = "/assets/images/onboarding/pencom_logo_transparent.png";

const MaintenanceLoading = () => {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className="min-h-screen w-full bg-off-white flex flex-col items-center justify-center px-6 py-10"
    >
      <img
        src={PENCOM_LOGO}
        alt="PenCom"
        className="h-[88px] w-auto object-contain mb-6 animate-pulse"
        loading="eager"
      />
      <p className="font-clash-display text-base text-medium-grey">
        Loading…
      </p>
    </div>
  );
};

export default MaintenanceLoading;
